import type { ReactNode } from "react";
import { InstituteLogo } from "@/components/InstituteLogo";
import { LoginRequired } from "@/components/LoginRequired";
import { usePlayerAuth } from "@/context/PlayerAuthContext";

/**
 * Lesson slides only for students with a valid community session (cookie / token).
 * Course outline may stay public; direct lesson links require login.
 */
export function RequireLessonAuth({ children }: { children: ReactNode }) {
  const { status, isAuthenticated } = usePlayerAuth();

  if (status === "loading") {
    return (
      <div className="min-h-full flex flex-col items-center justify-center gap-4 p-10 lp-theme-adult bg-gradient-to-b from-slate-50 to-indigo-50/30">
        <div className="rounded-2xl bg-white p-4 shadow-lg shadow-indigo-100/50 ring-1 ring-slate-100">
          <InstituteLogo height={56} />
        </div>
        <div className="flex items-center gap-2 text-slate-500 text-sm">
          <span
            className="inline-block h-4 w-4 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin"
            aria-hidden
          />
          Checking your session…
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginRequired variant="lesson" />;
  }

  return <>{children}</>;
}
